import React, { useState } from "react";
import "./RiskLevelChip.css";

type RiskLevel = "Critical" | "High" | "Medium" | "Low";

interface RiskLevelChipProps {
  riskLevel: RiskLevel;
  vulnerabilityCount: number;
  critical: number;
  high: number;
  medium: number;
  low: number;
}

const RISK_COLORS: Record<RiskLevel, string> = {
  Critical: "#ff4d4f",
  High: "#ff7a45",
  Medium: "#faad14",
  Low: "#52c41a",
};

const SEVERITY_KEYS = [
  { key: "critical" as const, label: "Critical", color: "#ff4d4f" },
  { key: "high" as const, label: "High", color: "#ff7a45" },
  { key: "medium" as const, label: "Medium", color: "#faad14" },
  { key: "low" as const, label: "Low", color: "#19bb93ff" },
];

const RiskLevelChip: React.FC<RiskLevelChipProps> = ({
  riskLevel,
  vulnerabilityCount,
  critical,
  high,
  medium,
  low,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const severityCounts = { critical, high, medium, low };

  return (
    <div
      className="risk-chip"
      style={{ borderColor: RISK_COLORS[riskLevel] }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <span className="risk-chip-dot" style={{ background: RISK_COLORS[riskLevel] }} />
      <span className="risk-chip-label" style={{ color: RISK_COLORS[riskLevel] }}>
        {riskLevel}
      </span>
      <span className="risk-chip-count">({vulnerabilityCount})</span>

      {/* Severity Tooltip */}
      {showTooltip && (
        <div className="risk-chip-tooltip">
          <div className="risk-chip-tooltip-header">Vulnerabilities Breakdown</div>
          {SEVERITY_KEYS.map(({ key, label, color }) => (
            <div className="risk-chip-tooltip-row" key={key}>
              <span className="risk-chip-tooltip-dot" style={{ background: color }} />
              <span className="risk-chip-tooltip-label">{label}</span>
              <span className="risk-chip-tooltip-count">{severityCounts[key]}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RiskLevelChip;